import React, { SVGProps } from "react";

export const Logo = (props: SVGProps<any>) => {
  return (
    <svg
      width={props.width || 100}
      height={props.height || 100}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="48" fill="url(#paint0_linear_10306_9957)" stroke="white" strokeWidth="4" />
      <path
        d="M72 7V46.3571C72 55.8623 75.8086 61 85.6283 61C95.448 61 96.6245 61 97 61"
        stroke="white"
        strokeWidth="3.45622"
        strokeLinecap="round"
      />
      <path
        d="M83 16V44.9484C83.0001 48 84.0676 51 89.9594 51C95.8512 51 97.7747 51 98 51"
        stroke="white"
        strokeWidth="3.45622"
        strokeLinecap="round"
      />
      <path
        d="M17 16V44.9484C16.9999 48 15.9324 51 10.0406 51C4.14881 51 2.22528 51 2 51"
        stroke="white"
        strokeWidth="3.45622"
        strokeLinecap="round"
      />
      <path
        d="M28 7V46.3571C28 55.8623 24.1914 61 14.3717 61C4.55198 61 3.37547 61 3 61"
        stroke="white"
        strokeWidth="3.45622"
        strokeLinecap="round"
      />
      <path
        d="M61.001 4L61.0923 56.8201C61.0011 62.5 66.3214 72 78.8902 72C91.4589 72 92.5193 72 92.9998 72"
        stroke="white"
        strokeWidth="3.45622"
        strokeLinecap="round"
      />
      <path
        d="M38.999 4L38.9077 56.8201C38.9989 62.5 33.6786 72 21.1098 72C8.54106 72 7.48074 72 7.00015 72"
        stroke="white"
        strokeWidth="3.45622"
        strokeLinecap="round"
      />
      <path
        d="M50 4L50.3153 62.4946C50 69.335 53.4838 84 67.2287 84C80.9736 84 83.4744 84 84 84"
        stroke="white"
        strokeWidth="3.45622"
        strokeLinecap="round"
      />
      <path
        d="M50 4V62.4738C49.9997 69.335 46.5162 84 32.7713 84C19.0264 84 16.5256 84 16 84"
        stroke="white"
        strokeWidth="3.45622"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10306_9957"
          x1="39.3313"
          y1="146.739"
          x2="145.015"
          y2="61.351"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9358F7" />
          <stop offset="0.259732" stopColor="#7B78F2" />
          <stop offset="0.500607" stopColor="#6197EE" />
          <stop offset="0.766547" stopColor="#45B5E9" />
          <stop offset="1" stopColor="#10D7E2" />
        </linearGradient>
      </defs>
    </svg>
  );
};
